import React, { useEffect, useState } from "react";
import style from "./style.module.css";

import Button from "../GroupFormLp/Button";
import BienTypeSelect from "../../components/v2/Listings/SearchBarComponent/components/BienTypeSelect";

import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "ui/CustomInput/Input";
function index({
  title,
  lang,
  transaction_type,
  province,
  t,
}: {
  title: string;
  lang: any;
  transaction_type?: string;
  province?: any;
  t: any;
}) {
  const dispatch = useDispatch();
  const listingsSearchPayload: any = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );

  const [prixMax, setPrixMax] = useState(0);

  const onTypesSelected = (types) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          type: types,
          shortName: null,
          page: 0,
        },
      })
    );
  };

  useEffect(() => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          prixmax: prixMax,
          shortName: null,
          page: 0,
        },
      })
    );
  }, [prixMax]);

  const handleRedirect = () => {
    window.open(
      `/${lang}/list.htm?transaction_type=${transaction_type}&prixmax=${
        listingsSearchPayload.prixmax
      }${
        province ? `&province=${province}` : ""
      }&type=${listingsSearchPayload.type.map((item) => {
        return item.toLowerCase();
      })}`
    );
  };

  return (
    <div className={style.container}>
      <div>
        <h2 className={style.title}>{title}</h2>
      </div>
      <div className={style.formLp}>
        <div>
          <label htmlFor="" className={style.label}>
            {t("Type de bien")}
          </label>
          <div className={style.selectType}>
            <BienTypeSelect
              transactionType={"Location"}
              onTypesSelected={onTypesSelected}
              fromLp={true}
            />
          </div>
        </div>
        <div className={style.budgetCon}>
          <div className={style.budget}>
            <label htmlFor="" className={style.label}>
              {t("Budget maximum")}
            </label>
            <CustomInput
              type="text"
              pattern="\d*"
              placeHolder={""}
              styleInput={style.input}
              styleContainer={style.inputContainer}
              styleInputFor={style.inputFor}
              value={
                prixMax
                  ? prixMax.toString().replace(/(.)(?=(\d{3})+$)/g, "$1 ")
                  : ""
              }
              onChange={(e) => {
                setPrixMax(parseInt(e.target.value.replace(/ /g, "")));
              }}
              inputFor={transaction_type == "Location" ? t("DH/MOIS") : t("DH")}
            />
          </div>
        </div>
        <div className={style.rechercheBtn}>
          <Button
            text={t("Rechercher")}
            icon={true}
            onClick={handleRedirect}
            fromLp={true}
          />
        </div>
      </div>
    </div>
  );
}

export default index;
